export default "__VITE_ASSET__WoXLPkLE__"